import React from 'react'
import { Icon } from '@iconify/react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const StandAlonePageTitle = props => {
  const { classes } = props

  return (
    <div className={classes.titleContainer}>
      <div className={classes.headerWrapper}>
        <Icon icon={'ph:map-pin-fill'} className={classes.icons} />
        <Typography className={classes.pageTitle}>Cover Page</Typography>
      </div>
      <div className={classes.divider}></div>
    </div>
  )
}

export default withStyles(styles)(StandAlonePageTitle)
